<template>
  <div id="Jan2025" class="202501 bg-center">
    <div class="logo py-4 md:hidden">
      <img src="~@/assets/images/202501/logo.png" class="object-contain mx-auto w-auto">
    </div>
    <div class="md:pt-12">
      <img src="~@/assets/images/202501/banner.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202501/m/banner.png" class="object-contain mx-auto md:hidden">
    </div>
    <div>
      <img src="~@/assets/images/202501/CON1.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202501/m/CON1.png" class="object-contain mx-auto md:hidden -mt-4">
    </div>

    <a class="plan1 mb-4" href="https://store.liveabc.com/products/magazine/sale?tag=446" target="_blank">
      <img src="~@/assets/images/202501/CON2.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202501/m/CON2.png" class="object-contain mx-auto md:hidden">
    </a>

    <div class="plan2 mb-4">
      <div class="">
        <img src="~@/assets/images/202501/head2.png" class="object-contain mx-auto hidden md:block">
      </div>
      <div class="">
        <img src="~@/assets/images/202501/tittle1.png" class="object-contain mx-auto hidden md:block">
      </div>
      <div class="flex justify-center max-w-6xl mx-auto">
        <div class="cloud_L">
          <img src="~@/assets/images/202501/cloud_L.png" class="object-contain mx-auto">
        </div>
        <div class="">
          <img src="~@/assets/images/202501/pop_white_L.png" class="object-contain mx-auto">
        </div>
        <div class="">
          <img src="~@/assets/images/202501/sneke.png" class="object-contain mx-auto">
        </div>
        <div class="">
          <img src="~@/assets/images/202501/pop_white_R.png" class="object-contain mx-auto">
        </div>
        <div class="cloud_R">
          <img src="~@/assets/images/202501/cloud_R.png" class="object-contain mx-auto">
        </div>
      </div>
      <div class="flex flex-wrap max-w-6xl mx-auto mb-4">
        <router-link target="_blank" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/3 md:w-1/4 p-2 border border-dashed border-yellow-jan"
          :class="{ 'md:border-t-0': (index === 0 || index === 1 || index === 2 || index === 3),
          'md:border-b-0': (index === 8 || index === 9 || index === 10 || index === 11),
          'md:border-l-0': (index === 0 || index === 4 || index === 8),
          'md:border-r-0': (index === 3 || index === 7 || index === 11),
          'border-t-0': (index === 0 || index === 1 || index === 2),
          'border-b-0': (index === 9 || index === 10 || index === 11) }" v-for="(item, index) in bookData" :key="index">
          <img :src="item.img_url" class="object-contain block">
        </router-link>
      </div>
      <a class="" href="https://store.liveabc.com/products/magazine/sale?tag=447" target="_blank">
        <img src="~@/assets/images/202501/more.png" class="object-contain mx-auto">
      </a>
    </div>

    <div class="plan3 mb-4">
      <div class="mb-3">
        <img src="~@/assets/images/202501/tittle3.png" class="object-contain mx-auto">
      </div>
      <div class="flex justify-center mb-3">
        <div class="">
          <img src="~@/assets/images/202501/live.png" class="object-contain mx-auto">
        </div>
        <div class="">
          <img src="~@/assets/images/202501/hiw.png" class="object-contain mx-auto">
        </div>
      </div>
      <div class="">
        <img src="~@/assets/images/202501/sub.png" class="object-contain mx-auto">
      </div>
      <a class="" href="https://store.liveabc.com/products/recent" target="_blank">
        <img src="~@/assets/images/202501/subscribe.png" class="object-contain mx-auto">
      </a>
    </div>

    <div class="plan4 mb-4">
      <a class="" href="https://store.liveabc.com/products/magazine/sale?tag=451" target="_blank">
        <img src="~@/assets/images/202501/Con4.png" class="object-contain mx-auto">
      </a>
      <a class="" href="https://store.liveabc.com/products/magazine/sale?tag=451" target="_blank">
        <img src="~@/assets/images/202501/con4-info.png" class="object-contain mx-auto -mt-4">
      </a>
    </div>

    <div class="footer text-white py-5">
      <div class="footer-inner">
        <div class="max-w-5xl text-center mx-auto leading-loose mb-4">
          <p class="text-lg mb-1">注意事項</p>
          <p class="text-sm">‧贈品數量有限，送完為止，若贈送完畢，得以等值贈品替換。‧</p>
          <p class="text-sm">‧活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。‧ </p>
        </div>
        <router-link :to="{ name: 'index' }" class="block p-2" target="_blank">
          <img src="~@/assets/images/202501/logo.png" class="object-contain mx-auto">
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'October2024',
  metaInfo () {
    return {
      title: '2025年開春獻優惠🎁｜全館消費滿額雙重送',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      bookData: [
        { id: 10235, img_url: require('@/assets/images/202501/book/1.png') },
        { id: 8461, img_url: require('@/assets/images/202501/book/2.png') },
        { id: 7455, img_url: require('@/assets/images/202501/book/3.png') },
        { id: 7801, img_url: require('@/assets/images/202501/book/4.png') },
        { id: 4658, img_url: require('@/assets/images/202501/book/5.png') },
        { id: 6573, img_url: require('@/assets/images/202501/book/6.png') },
        { id: 8158, img_url: require('@/assets/images/202501/book/7.png') },
        { id: 9669, img_url: require('@/assets/images/202501/book/8.png') },
        { id: 8973, img_url: require('@/assets/images/202501/book/9.png') },
        { id: 8737, img_url: require('@/assets/images/202501/book/10.png') },
        { id: 7732, img_url: require('@/assets/images/202501/book/11.png') },
        { id: 7649, img_url: require('@/assets/images/202501/book/12.png') }

      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#Jan2025 {
  background-color: rgb(237, 70, 46);
  .border-yellow-jan {
    border-color: #F7DD31;
  }

  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .toggle-btn {
    top: 20%;
    left: -50%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    left: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    left: -174px;
    transition: 0.3s;
  }

}

</style>
